import { render } from "./AddPhase.vue?vue&type=template&id=1cb4d062"
import script from "./AddPhase.vue?vue&type=script&lang=js"
export * from "./AddPhase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./AddPhase.vue?vue&type=style&index=0&id=1cb4d062&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script